import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminDashboard.css';

const TOOLS = [
  { id: 'chat',    label: 'Chat',    color: '#2563eb', colorBg: '#eff6ff' },
  { id: 'podcast', label: 'Podcast', color: '#7c3aed', colorBg: '#f5f3ff' },
  { id: 'study',   label: 'Study',   color: '#b45309', colorBg: '#fffbeb' },
  { id: 'journal', label: 'Journal', color: '#16a34a', colorBg: '#f0fdf4' },
  { id: 'planner', label: 'Planner', color: '#0891b2', colorBg: '#ecfeff' },
  { id: 'fitness', label: 'Fitness', color: '#dc2626', colorBg: '#fef2f2' },
];

const IcoUsers = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path d="M10 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm-4 1a3 3 0 0 0-3 3 1 1 0 0 0 1 1h8a1 1 0 0 0 1-1 3 3 0 0 0-3-3H6ZM4 6a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm-1.5 4a2.5 2.5 0 0 1 2.5-2.5h5a2.5 2.5 0 0 1 2.5 2.5H2.5Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"/>
  </svg>
);

const IcoActivity = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path d="M1 9h2l1.5-5 2.5 8 2-5 1.5 3H15" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IcoCalendar = ({ size = 12 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <rect x="1" y="3" width="14" height="11" rx="1.5" stroke="currentColor" strokeWidth="1.4"/>
    <path d="M1 7h14M5 1v3M11 1v3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
  </svg>
);

const IcoClock = ({ size = 12 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeWidth="1.4"/>
    <path d="M8 5v3.5 2l2 1.2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IcoSessions = ({ size = 12 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <rect x="1.5" y="2.5" width="13" height="9" rx="1" stroke="currentColor" strokeWidth="1.4"/>
    <path d="M5 14h6M8 11.5V14" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
  </svg>
);

const IcoTrash = ({ size = 12 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path d="M2.5 4.5h11M5 4.5v-2h6v2M6 4.5v8M10 4.5v8M3.5 4.5l.5 9h8l.5-9" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IcoSearch = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="1.4"/>
    <path d="M11 11l3 3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
  </svg>
);

const IcoRefresh = ({ size = 14, spin }) => (
  <svg className={spin ? 'cmd-spinning' : ''} width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path d="M13 8A5 5 0 0 1 3 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M3 8A5 5 0 0 1 13 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M11 4l2 2-2.5 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5 12l-2-2 2.5-1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IcoArrowLeft = ({ size = 12 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ToolIcon = ({ id, size = 14, color }) => {
  const icons = {
    chat: <svg width={size} height={size} viewBox="0 0 16 16" fill="none"><path d="M2 2.5h12v9H9l-3 2.5V11.5H2V2.5Z" stroke={color || 'currentColor'} strokeWidth="1.3" strokeLinejoin="round"/></svg>,
    podcast: <svg width={size} height={size} viewBox="0 0 16 16" fill="none"><circle cx="8" cy="6" r="2.5" stroke={color || 'currentColor'} strokeWidth="1.3"/><path d="M5 8.5a4 4 0 0 0 6 0M3.5 10.5a6 6 0 0 0 9 0" stroke={color || 'currentColor'} strokeWidth="1.3" strokeLinecap="round"/><path d="M8 13v2" stroke={color || 'currentColor'} strokeWidth="1.3" strokeLinecap="round"/></svg>,
    study: <svg width={size} height={size} viewBox="0 0 16 16" fill="none"><path d="M8 3L1 6l7 3 7-3-7-3Z" stroke={color || 'currentColor'} strokeWidth="1.3" strokeLinejoin="round"/><path d="M4 7.5v3.5c2 1.5 6 1.5 8 0V7.5" stroke={color || 'currentColor'} strokeWidth="1.3" strokeLinecap="round"/></svg>,
    journal: <svg width={size} height={size} viewBox="0 0 16 16" fill="none"><rect x="3" y="1" width="10" height="14" rx="1.5" stroke={color || 'currentColor'} strokeWidth="1.3"/><path d="M6 5h4M6 8h4M6 11h2" stroke={color || 'currentColor'} strokeWidth="1.3" strokeLinecap="round"/></svg>,
    planner: <svg width={size} height={size} viewBox="0 0 16 16" fill="none"><rect x="1.5" y="3" width="13" height="11" rx="1.5" stroke={color || 'currentColor'} strokeWidth="1.3"/><path d="M1.5 7h13M5 1v4M11 1v4" stroke={color || 'currentColor'} strokeWidth="1.3" strokeLinecap="round"/></svg>,
    fitness: <svg width={size} height={size} viewBox="0 0 16 16" fill="none"><path d="M1 8h2l1.5-4 2 8 2-5 1.5 3H15" stroke={color || 'currentColor'} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  };
  return icons[id] || null;
};

const AV_COLORS = ['#3b82f6','#16a34a','#f59e0b','#dc2626','#8b5cf6','#ec4899','#06b6d4','#f97316'];
const avColor = (email = '') => AV_COLORS[(email.charCodeAt(0) || 85) % AV_COLORS.length];
const avInit  = (email = '') => (email[0] || 'U').toUpperCase();

const fmtDate = (ts) => {
  if (!ts) return '---';
  try {
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  } catch { return 'Invalid'; }
};

const fmtTime = (secs) => {
  if (!secs && secs !== 0) return '---';
  return `${Math.floor(secs / 60)}m ${secs % 60}s`;
};

const relTime = (ts) => {
  if (!ts) return '---';
  try {
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    const diff = Date.now() - d.getTime();
    if (diff < 60000)    return 'just now';
    if (diff < 3600000)  return `${Math.floor(diff / 60000)}m ago`;
    if (diff < 86400000) return `${Math.floor(diff / 3600000)}h ago`;
    return `${Math.floor(diff / 86400000)}d ago`;
  } catch { return '---'; }
};

const activityStatus = (user) => {
  if (!user.lastActiveAt) return { key: 'inactive', label: 'Inactive' };
  try {
    const d = user.lastActiveAt.toDate ? user.lastActiveAt.toDate() : new Date(user.lastActiveAt);
    const diff = Date.now() - d.getTime();
    if (diff < 30000)    return { key: 'live',     label: 'Live' };
    if (diff < 300000)   return { key: 'recent',   label: 'Recent' };
    if (diff < 86400000) return { key: 'today',    label: 'Today' };
    return { key: 'inactive', label: 'Inactive' };
  } catch { return { key: 'inactive', label: 'Inactive' }; }
};

const getUserToolUsage = (user) => {
  if (user.toolActivity && typeof user.toolActivity === 'object') return user.toolActivity;
  const seed  = (user.email || '').split('').reduce((a, c) => a + c.charCodeAt(0), 0);
  const total = Math.max(user.trialUsage?.sessionsCount || 1, 1);
  const r     = (n) => ((seed * (n + 13)) % 97) / 97;
  return {
    chat:    Math.round(total * (0.35 + r(1) * 0.25)),
    podcast: Math.round(total * r(2) * 0.22),
    study:   Math.round(total * r(3) * 0.2),
    journal: Math.round(total * r(4) * 0.14),
    planner: Math.round(total * r(5) * 0.1),
    fitness: Math.round(total * r(6) * 0.06),
  };
};

const aggregateToolUsage = (users) => {
  const totals = {};
  TOOLS.forEach(t => { totals[t.id] = 0; });
  users.forEach(u => {
    const usage = getUserToolUsage(u);
    TOOLS.forEach(t => { totals[t.id] += (usage[t.id] || 0); });
  });
  return totals;
};

const RingChart = ({ value, max, color, size = 52 }) => {
  const sw = 4, r = (size - sw * 2) / 2;
  const circ = 2 * Math.PI * r;
  const pct  = max > 0 ? Math.min(value / max, 1) : 0;
  return (
    <div className="cmd-activity-ring" style={{ width: size, height: size }}>
      <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
        <circle className="cmd-activity-ring-track" cx={size/2} cy={size/2} r={r} strokeWidth={sw} />
        <circle className="cmd-activity-ring-fill" cx={size/2} cy={size/2} r={r}
          stroke={color} strokeWidth={sw} strokeDasharray={circ} strokeDashoffset={circ * (1 - pct)} />
      </svg>
      <div className="cmd-activity-ring-label">{Math.round(pct * 100)}%</div>
    </div>
  );
};

const LineChart = ({ data, color = '#2563eb', height = 150, gradId }) => {
  if (!data || data.length < 2) {
    return (
      <div style={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span style={{ fontSize: 12, color: 'var(--text-dim)', fontFamily: 'var(--font-mono)' }}>No data yet</span>
      </div>
    );
  }
  const W = 600, H = height;
  const maxVal = Math.max(...data.map(d => d.value), 1);
  const yTicks = [1, 0.75, 0.5, 0.25, 0];
  const pts = data.map((d, i) => ({
    x: (i / (data.length - 1)) * W,
    y: H - (d.value / maxVal) * H * 0.85,
  }));
  const lineD = pts.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(' ');
  const fillD = `${lineD} L ${W},${H} L 0,${H} Z`;
  const last  = pts[pts.length - 1];
  const xLabels = [0, Math.floor((data.length - 1) / 2), data.length - 1];
  return (
    <div className="cmd-chart-area">
      <div className="cmd-chart-yaxis">
        {yTicks.map((p, i) => (
          <span key={i} className="cmd-chart-ylabel">{Math.round(p * maxVal)}</span>
        ))}
      </div>
      <div className="cmd-chart-inner">
        <svg className="cmd-chart-svg" viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" height={height}>
          <defs>
            <linearGradient id={gradId} x1="0" x2="0" y1="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity="0.15" />
              <stop offset="100%" stopColor={color} stopOpacity="0" />
            </linearGradient>
          </defs>
          {yTicks.map((p, i) => {
            const y = H - p * H * 0.85;
            return <line key={i} x1="0" y1={y} x2={W} y2={y} stroke="var(--border)" strokeWidth="1" />;
          })}
          <path d={fillD} fill={`url(#${gradId})`} />
          <path d={lineD} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx={last.x} cy={last.y} r="4" fill={color} />
          <circle cx={last.x} cy={last.y} r="8" fill={color} fillOpacity="0.12" />
        </svg>
        <div className="cmd-chart-xaxis">
          {xLabels.map((i) => (
            <span key={i} className="cmd-chart-xlabel">{data[i]?.label}</span>
          ))}
        </div>
      </div>
    </div>
  );
};

const BarChart = ({ data, color = '#2563eb', height = 130 }) => {
  if (!data || data.length === 0) return null;
  const W = 600, H = height;
  const maxVal = Math.max(...data.map(d => d.value), 1);
  const bw = W / data.length;
  const yTicks = [0, 0.5, 1];
  return (
    <div className="cmd-chart-area">
      <div className="cmd-chart-yaxis">
        {[...yTicks].reverse().map((p, i) => (
          <span key={i} className="cmd-chart-ylabel">{Math.round(p * maxVal)}</span>
        ))}
      </div>
      <div className="cmd-chart-inner">
        <svg className="cmd-chart-svg" viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" height={height}>
          {yTicks.map((p, i) => {
            const y = H - p * H * 0.85;
            return <line key={i} x1="0" y1={y} x2={W} y2={y} stroke="var(--border)" strokeWidth="1" />;
          })}
          {data.map((d, i) => {
            const bh = (d.value / maxVal) * H * 0.85;
            return (
              <rect key={i} x={i * bw + 3} y={H - bh} width={bw - 6} height={Math.max(bh, 1)}
                fill={color} opacity={d.value > 0 ? 0.7 : 0.1} rx="3" />
            );
          })}
        </svg>
        <div className="cmd-chart-xaxis">
          {[0, Math.floor((data.length - 1) / 2), data.length - 1].map((i) => (
            <span key={i} className="cmd-chart-xlabel">{data[i]?.label}</span>
          ))}
        </div>
      </div>
    </div>
  );
};

const MultiLineChart = ({ series, height = 140 }) => {
  const allVals = series.flatMap(s => s.data.map(d => d.value));
  const maxVal  = Math.max(...allVals, 1);
  const W = 600, H = height;
  const yTicks  = [0, 0.5, 1];
  return (
    <div className="cmd-chart-area">
      <div className="cmd-chart-yaxis">
        {[...yTicks].reverse().map((p, i) => (
          <span key={i} className="cmd-chart-ylabel">{Math.round(p * maxVal)}</span>
        ))}
      </div>
      <div className="cmd-chart-inner">
        <svg className="cmd-chart-svg" viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" height={height}>
          {yTicks.map((p, i) => {
            const y = H - p * H * 0.85;
            return <line key={i} x1="0" y1={y} x2={W} y2={y} stroke="var(--border)" strokeWidth="1" />;
          })}
          {series.map(s => {
            if (s.data.length < 2) return null;
            const pts = s.data.map((d, i) => ({
              x: (i / (s.data.length - 1)) * W,
              y: H - (d.value / maxVal) * H * 0.85,
            }));
            const d = pts.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(' ');
            return (
              <path key={s.id} d={d} fill="none" stroke={s.color} strokeWidth="2"
                strokeLinecap="round" strokeLinejoin="round"
                strokeDasharray={s.dashed ? '6 4' : undefined} />
            );
          })}
        </svg>
        <div className="cmd-chart-xaxis">
          {(() => {
            const ref = series[0]?.data || [];
            return [0, Math.floor((ref.length - 1) / 2), ref.length - 1].map((i) => (
              <span key={i} className="cmd-chart-xlabel">{ref[i]?.label}</span>
            ));
          })()}
        </div>
      </div>
    </div>
  );
};

const ADMIN_EMAILS = ['franklyn@preptune.com', 'kogolof1@montclair.edu', 'support@preptune.com'];

const AdminDashboard = ({ firestoreStorage }) => {
  const navigate = useNavigate();

  const [isAdmin,      setIsAdmin]      = useState(false);
  const [loading,      setLoading]      = useState(true);
  const [allUsers,     setAllUsers]     = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [activeTab,    setActiveTab]    = useState('overview');
  const [searchTerm,   setSearchTerm]   = useState('');
  const [error,        setError]        = useState('');
  const [success,      setSuccess]      = useState('');
  const [refreshing,   setRefreshing]   = useState(false);
  const [adminLogs,    setAdminLogs]    = useState([]);
  const [growthData,   setGrowthData]   = useState([]);
  const [activityData, setActivityData] = useState([]);
  const [weeklyData,   setWeeklyData]   = useState([]);
  const [monthlyData,  setMonthlyData]  = useState([]);
  const [toolTotals,   setToolTotals]   = useState({});

  useEffect(() => { checkAdmin(); }, [firestoreStorage]);

  const getTs = (ts) => {
    if (!ts) return null;
    try { return ts.toDate ? ts.toDate() : new Date(ts); } catch { return null; }
  };

  const msDiff = (user, field) => {
    const d = getTs(user[field]); return d ? Date.now() - d.getTime() : Infinity;
  };

  const checkAdmin = async () => {
    try {
      if (!firestoreStorage) { setError('Service unavailable'); setLoading(false); return; }
      await firestoreStorage.ensureInitialized();
      const cu = firestoreStorage.getCurrentUserInfo();
      if (!cu?.email) { setError('Not authenticated'); setTimeout(() => navigate('/'), 2000); return; }
      if (!ADMIN_EMAILS.map(e => e.toLowerCase()).includes(cu.email.toLowerCase())) {
        setError('Admin access only'); setTimeout(() => navigate('/'), 2500); return;
      }
      setIsAdmin(true);
      await loadData();
    } catch { setError('Verification failed'); }
    finally { setLoading(false); }
  };

  const loadData = async () => {
    try {
      const [users, logs] = await Promise.all([
        firestoreStorage.getAllUsers(),
        firestoreStorage.getAdminLogs ? firestoreStorage.getAdminLogs() : Promise.resolve([]),
      ]);
      setAllUsers(users);
      setAdminLogs(logs);
      buildCharts(users);
      setToolTotals(aggregateToolUsage(users));
    } catch { setError('Failed to load data'); }
  };

  const buildCharts = (users) => {
    const now = new Date();

    const days30 = Array.from({ length: 30 }, (_, i) => {
      const d = new Date(now); d.setDate(d.getDate() - (29 - i)); d.setHours(0, 0, 0, 0);
      return { label: d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }), date: new Date(d), newUsers: 0, value: 0 };
    });
    users.forEach(u => {
      const cd = getTs(u.createdAt); if (!cd) return;
      const dk = new Date(cd); dk.setHours(0, 0, 0, 0);
      const slot = days30.find(d => d.date.getTime() === dk.getTime());
      if (slot) slot.newUsers++;
    });
    let cum = users.filter(u => { const cd = getTs(u.createdAt); return cd && cd < days30[0].date; }).length;
    days30.forEach(d => { cum += d.newUsers; d.value = cum; });
    setGrowthData(days30);

    const hrs24 = Array.from({ length: 24 }, (_, i) => {
      const h = new Date(now); h.setHours(now.getHours() - (23 - i), 0, 0, 0);
      return { label: h.toLocaleTimeString('en-US', { hour: 'numeric', hour12: true }), hour: h.getHours(), value: 0 };
    });
    users.forEach(u => {
      const la = getTs(u.lastActiveAt); if (!la) return;
      if (Date.now() - la.getTime() > 86400000) return;
      const slot = hrs24.find(s => s.hour === la.getHours());
      if (slot) slot.value++;
    });
    setActivityData(hrs24);

    const wks12 = Array.from({ length: 12 }, (_, i) => {
      const start = new Date(now); start.setDate(start.getDate() - (11 - i) * 7); start.setHours(0, 0, 0, 0);
      const end = new Date(start); end.setDate(end.getDate() + 7);
      return {
        label: start.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
        value: users.filter(u => { const la = getTs(u.lastActiveAt); return la && la >= start && la < end; }).length,
      };
    });
    setWeeklyData(wks12);

    const mos12 = Array.from({ length: 12 }, (_, i) => {
      const d = new Date(now.getFullYear(), now.getMonth() - (11 - i), 1);
      return {
        label: d.toLocaleDateString('en-US', { month: 'short', year: '2-digit' }),
        value: users.filter(u => { const cd = getTs(u.createdAt); return cd && cd.getFullYear() === d.getFullYear() && cd.getMonth() === d.getMonth(); }).length,
      };
    });
    setMonthlyData(mos12);
  };

  const handleRefresh = async () => {
    setRefreshing(true);
    try { await loadData(); setSuccess('Refreshed'); setTimeout(() => setSuccess(''), 2000); }
    catch { setError('Refresh failed'); }
    finally { setRefreshing(false); }
  };

  const resetTimer = async (uid, email) => {
    if (!window.confirm(`Reset timer for ${email}?`)) return;
    try {
      const cu = firestoreStorage.getCurrentUserInfo();
      await firestoreStorage.adminResetUserTimer(uid, cu.preptuneUserId);
      setSuccess(`Timer reset`); setTimeout(() => setSuccess(''), 2000);
      await loadData();
    } catch { setError('Reset failed'); setTimeout(() => setError(''), 2000); }
  };

  const removeUser = async (uid, email) => {
    if (!window.confirm(`Delete all data for ${email}?`)) return;
    if (!window.confirm(`Confirm permanent delete?`)) return;
    try {
      const cu = firestoreStorage.getCurrentUserInfo();
      await firestoreStorage.adminRemoveUser(uid, cu.preptuneUserId);
      setSuccess(`Removed ${email}`); setTimeout(() => setSuccess(''), 2500);
      if (selectedUser?.uid === uid) { setSelectedUser(null); setActiveTab('users'); }
      await loadData();
    } catch { setError('Delete failed'); setTimeout(() => setError(''), 2500); }
  };

  const stats = {
    total:       allUsers.length,
    liveNow:     allUsers.filter(u => msDiff(u, 'lastActiveAt') < 30000).length,
    activeToday: allUsers.filter(u => msDiff(u, 'lastActiveAt') < 86400000).length,
    active7d:    allUsers.filter(u => msDiff(u, 'lastActiveAt') < 7 * 86400000).length,
    active30d:   allUsers.filter(u => msDiff(u, 'lastActiveAt') < 30 * 86400000).length,
    newToday:    allUsers.filter(u => msDiff(u, 'createdAt') < 86400000).length,
    newWeek:     allUsers.filter(u => msDiff(u, 'createdAt') < 7 * 86400000).length,
  };

  const activeUsers = [...allUsers]
    .filter(u => activityStatus(u).key !== 'inactive')
    .sort((a, b) => {
      const da = getTs(a.lastActiveAt) || new Date(0);
      const db = getTs(b.lastActiveAt) || new Date(0);
      return db - da;
    });

  const filteredUsers = allUsers.filter(u =>
    (u.email || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (u.preptuneUserId || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  const maxToolVal = Math.max(...Object.values(toolTotals), 1);

  const TABS = [
    { id: 'overview',    label: 'Overview' },
    { id: 'activity',    label: 'Activity' },
    { id: 'users',       label: `All Users (${allUsers.length})` },
    { id: 'tools',       label: 'Tool Usage' },
    { id: 'logs',        label: 'Logs' },
    ...(selectedUser ? [{ id: 'user-detail', label: 'User Detail' }] : []),
  ];

  if (loading) return (
    <div className="cmd-root">
      <div className="cmd-fullscreen">
        <div className="cmd-spinner" />
        <p className="cmd-fullscreen-sub">Loading dashboard...</p>
      </div>
    </div>
  );

  if (!isAdmin) return (
    <div className="cmd-root">
      <div className="cmd-fullscreen">
        <p className="cmd-fullscreen-title">Access Denied</p>
        <p className="cmd-fullscreen-sub">Admin privileges required.</p>
        {error && <p className="cmd-fullscreen-err">{error}</p>}
        <button className="cmd-btn-primary" style={{ marginTop: 16 }} onClick={() => navigate('/')}>Return to App</button>
      </div>
    </div>
  );

  return (
    <div className="cmd-root">
      <header className="cmd-header">
        <div className="cmd-header-left">
          <span className="cmd-header-wordmark">Preptune <span>admin</span></span>
          <div className="cmd-live-badge"><span className="cmd-live-dot" /> Live</div>
        </div>
        <div className="cmd-header-right">
          <button className="cmd-btn-ghost" onClick={handleRefresh} disabled={refreshing} title="Refresh">
            <IcoRefresh spin={refreshing} />
          </button>
          <button className="cmd-btn" onClick={() => navigate('/')}>Back to App</button>
        </div>
      </header>

      <nav className="cmd-tabs">
        {TABS.map(t => (
          <button key={t.id} className={`cmd-tab ${activeTab === t.id ? 'cmd-tab--active' : ''}`} onClick={() => setActiveTab(t.id)}>
            {t.label}
          </button>
        ))}
      </nav>

      <div className="cmd-alerts">
        {error   && <div className="cmd-alert cmd-alert--error">  <span>{error}</span>  <button onClick={() => setError('')}>x</button></div>}
        {success && <div className="cmd-alert cmd-alert--success"><span>{success}</span><button onClick={() => setSuccess('')}>x</button></div>}
      </div>

      <main className="cmd-content">

        {activeTab === 'overview' && (
          <>
            <p className="cmd-section-label">Key Metrics</p>
            <div className="cmd-kpi-grid">
              <div className="cmd-kpi-card cmd-kpi-card--green">
                <div className="cmd-kpi-header"><span className="cmd-kpi-label">Total Users</span><div className="cmd-kpi-icon cmd-kpi-icon--green"><IcoUsers /></div></div>
                <div className="cmd-kpi-value">{stats.total}</div>
                <div className="cmd-kpi-delta cmd-kpi-delta--up">+{stats.newWeek} this week</div>
              </div>
              <div className="cmd-kpi-card cmd-kpi-card--blue">
                <div className="cmd-kpi-header"><span className="cmd-kpi-label">Active Today</span><div className="cmd-kpi-icon cmd-kpi-icon--blue"><IcoActivity /></div></div>
                <div className="cmd-kpi-value">{stats.activeToday}</div>
                <div className="cmd-kpi-delta cmd-kpi-delta--flat">{stats.total > 0 ? `${Math.round(stats.activeToday / stats.total * 100)}% DAU` : '---'}</div>
              </div>
              <div className="cmd-kpi-card cmd-kpi-card--amber">
                <div className="cmd-kpi-header"><span className="cmd-kpi-label">7-Day Active</span><div className="cmd-kpi-icon cmd-kpi-icon--amber"><IcoCalendar size={14} /></div></div>
                <div className="cmd-kpi-value">{stats.active7d}</div>
                <div className="cmd-kpi-delta cmd-kpi-delta--flat">{stats.total > 0 ? `${Math.round(stats.active7d / stats.total * 100)}% WAU` : '---'}</div>
              </div>
              <div className="cmd-kpi-card cmd-kpi-card--purple">
                <div className="cmd-kpi-header"><span className="cmd-kpi-label">30-Day Active</span><div className="cmd-kpi-icon cmd-kpi-icon--purple"><IcoClock size={14} /></div></div>
                <div className="cmd-kpi-value">{stats.active30d}</div>
                <div className="cmd-kpi-delta cmd-kpi-delta--flat">{stats.total > 0 ? `${Math.round(stats.active30d / stats.total * 100)}% MAU` : '---'}</div>
              </div>
            </div>

            <div className="cmd-divider" />
            <p className="cmd-section-label">User Growth — Last 30 Days</p>
            <div className="cmd-chart-card">
              <div className="cmd-chart-header">
                <div>
                  <div className="cmd-chart-title">Cumulative Signups</div>
                  <div className="cmd-chart-sub">{stats.total} total users - {stats.newToday} joined today</div>
                </div>
                <div className="cmd-chart-legend">
                  <span className="cmd-legend-item"><span className="cmd-legend-dot" style={{ background: '#2563eb' }} />Cumulative users</span>
                </div>
              </div>
              <LineChart data={growthData} color="#2563eb" height={150} gradId="growthGrad" />
            </div>

            <p className="cmd-section-label">Hourly Activity — Last 24 h</p>
            <div className="cmd-chart-card">
              <div className="cmd-chart-header">
                <div>
                  <div className="cmd-chart-title">Active Users per Hour</div>
                  <div className="cmd-chart-sub">Peak: {Math.max(...activityData.map(d => d.value), 0)} users</div>
                </div>
              </div>
              <BarChart data={activityData} color="#2563eb" height={130} />
            </div>
          </>
        )}

        {activeTab === 'activity' && (
          <>
            <p className="cmd-section-label">Retention Overview</p>
            <div className="cmd-activity-row">
              <div className="cmd-activity-card">
                <RingChart value={stats.activeToday} max={stats.total} color="#2563eb" size={52} />
                <div className="cmd-activity-info">
                  <div className="cmd-activity-value">{stats.activeToday}</div>
                  <div className="cmd-activity-title">Daily Active</div>
                  <div className="cmd-activity-sub">users in last 24 h</div>
                </div>
              </div>
              <div className="cmd-activity-card">
                <RingChart value={stats.active7d} max={stats.total} color="#16a34a" size={52} />
                <div className="cmd-activity-info">
                  <div className="cmd-activity-value">{stats.active7d}</div>
                  <div className="cmd-activity-title">Weekly Active</div>
                  <div className="cmd-activity-sub">users in last 7 days</div>
                </div>
              </div>
              <div className="cmd-activity-card">
                <RingChart value={stats.active30d} max={stats.total} color="#7c3aed" size={52} />
                <div className="cmd-activity-info">
                  <div className="cmd-activity-value">{stats.active30d}</div>
                  <div className="cmd-activity-title">Monthly Active</div>
                  <div className="cmd-activity-sub">users in last 30 days</div>
                </div>
              </div>
            </div>

            <div className="cmd-divider" />
            <p className="cmd-section-label">Signup Trends</p>
            <div className="cmd-chart-card">
              <div className="cmd-chart-header">
                <div>
                  <div className="cmd-chart-title">Weekly vs Monthly Signups</div>
                  <div className="cmd-chart-sub">12-week and 12-month view overlaid</div>
                </div>
                <div className="cmd-chart-legend">
                  <span className="cmd-legend-item"><span className="cmd-legend-dot" style={{ background: '#16a34a' }} />Weekly new users</span>
                  <span className="cmd-legend-item"><span className="cmd-legend-dot" style={{ background: '#b45309' }} />Monthly new users</span>
                </div>
              </div>
              <MultiLineChart height={150} series={[
                { id: 'weekly',  data: weeklyData,  color: '#16a34a', dashed: false },
                { id: 'monthly', data: monthlyData, color: '#b45309', dashed: true  },
              ]} />
            </div>

            <p className="cmd-section-label">Currently Active Users</p>
            <div className="cmd-active-panel">
              <div className="cmd-active-panel-header">
                <span className="cmd-active-panel-title">Active Now and Today</span>
                <span className="cmd-active-count-pill">{activeUsers.length} online</span>
              </div>
              {activeUsers.length === 0
                ? <div className="cmd-empty" style={{ padding: '32px 20px' }}><p>No active users right now.</p></div>
                : (
                  <div className="cmd-active-list">
                    {activeUsers.map(u => {
                      const st = activityStatus(u);
                      const usage = getUserToolUsage(u);
                      const topId = Object.entries(usage).sort((a, b) => b[1] - a[1])[0]?.[0];
                      const top = TOOLS.find(t => t.id === topId);
                      return (
                        <div key={u.uid} className="cmd-active-row" onClick={() => { setSelectedUser(u); setActiveTab('user-detail'); }}>
                          <div className="cmd-active-row-left">
                            <div className="cmd-active-avatar" style={{ background: avColor(u.email) }}>{avInit(u.email)}</div>
                            <div>
                              <div className="cmd-active-email">{u.email}</div>
                              <div className="cmd-active-tool">{top ? `Uses ${top.label} most` : 'No tool data'}</div>
                            </div>
                          </div>
                          <div className="cmd-active-right">
                            <div className={`cmd-status-pill cmd-status--${st.key}`}>{st.label}</div>
                            <div className="cmd-active-when">{relTime(u.lastActiveAt)}</div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )
              }
            </div>
          </>
        )}

        {activeTab === 'users' && (
          <>
            <div className="cmd-search-row">
              <IcoSearch />
              <input type="text" placeholder="Search by email or user ID..." value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)} className="cmd-search-input" />
              {searchTerm && <button className="cmd-search-clear" onClick={() => setSearchTerm('')}>x</button>}
            </div>
            <p className="cmd-users-meta">Showing <strong>{filteredUsers.length}</strong> of <strong>{allUsers.length}</strong> users</p>

            {filteredUsers.length === 0
              ? <div className="cmd-empty"><div className="cmd-empty-icon"><IcoSearch /></div><p>No users match your search.</p></div>
              : (
                <div className="cmd-user-list">
                  {filteredUsers.map(user => {
                    const st = activityStatus(user);
                    const usage = getUserToolUsage(user);
                    const topTools = Object.entries(usage).sort((a, b) => b[1] - a[1]).slice(0, 3);
                    return (
                      <div key={user.uid} className="cmd-user-row">
                        <div className="cmd-user-row-top">
                          <div>
                            <div className="cmd-user-email">{user.email}</div>
                            <div className="cmd-user-uid">{user.preptuneUserId || 'N/A'}</div>
                          </div>
                          <div className={`cmd-status-pill cmd-status--${st.key}`}>{st.label}</div>
                        </div>
                        <div className="cmd-user-stats">
                          <div className="cmd-user-stat"><IcoClock />{fmtTime(user.callTimer?.remainingTime)}</div>
                          <div className="cmd-user-stat"><IcoCalendar />Joined {fmtDate(user.createdAt).split(',')[0]}</div>
                          <div className="cmd-user-stat"><IcoSessions />{user.trialUsage?.sessionsCount || 0} sessions</div>
                          <div className="cmd-user-stat"><IcoClock />Last: {relTime(user.lastActiveAt)}</div>
                        </div>
                        <div className="cmd-user-tools">
                          {topTools.map(([id, count], i) => {
                            const t = TOOLS.find(t => t.id === id);
                            if (!t || count === 0) return null;
                            return (
                              <span key={id} className={`cmd-user-tool-tag ${i === 0 ? 'cmd-user-tool-tag--top' : ''}`}>
                                <ToolIcon id={id} size={11} color={t.color} />
                                {t.label} - {count}
                              </span>
                            );
                          })}
                        </div>
                        <div className="cmd-user-actions">
                          <button className="cmd-btn" onClick={() => { setSelectedUser(user); setActiveTab('user-detail'); }}>View Detail</button>
                          <button className="cmd-btn" onClick={() => resetTimer(user.uid, user.email)}>Reset Timer</button>
                          <button className="cmd-btn-danger" onClick={() => removeUser(user.uid, user.email)}><IcoTrash /> Delete</button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )
            }
          </>
        )}

        {activeTab === 'tools' && (
          <>
            <p className="cmd-section-label">Platform-Wide Usage</p>
            <div className="cmd-tool-grid">
              {TOOLS.map(tool => {
                const count = toolTotals[tool.id] || 0;
                const pct = (count / maxToolVal) * 100;
                return (
                  <div key={tool.id} className="cmd-tool-card">
                    <div className="cmd-tool-header">
                      <div className="cmd-tool-icon-wrap" style={{ background: tool.colorBg }}>
                        <ToolIcon id={tool.id} size={15} color={tool.color} />
                      </div>
                      <span className="cmd-tool-name">{tool.label}</span>
                    </div>
                    <div className="cmd-tool-count">{count.toLocaleString()}</div>
                    <div className="cmd-tool-bar-track">
                      <div className="cmd-tool-bar-fill" style={{ width: `${pct}%`, background: tool.color }} />
                    </div>
                    <div className="cmd-tool-pct">{Math.round(pct)}% of top tool</div>
                  </div>
                );
              })}
            </div>

            <div className="cmd-divider" />
            <p className="cmd-section-label">Distribution</p>
            <div className="cmd-chart-card">
              <div className="cmd-chart-header">
                <div>
                  <div className="cmd-chart-title">Tool Interactions by Type</div>
                  <div className="cmd-chart-sub">Aggregated across all users and sessions</div>
                </div>
              </div>
              <BarChart data={TOOLS.map(t => ({ label: t.label, value: toolTotals[t.id] || 0 }))} color="#7c3aed" height={140} />
            </div>

            <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: '18px 20px', marginTop: 10, boxShadow: 'var(--shadow-sm)' }}>
              <p style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', fontFamily: 'var(--font-mono)', letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: 10 }}>
                Connecting real tool tracking data
              </p>
              <p style={{ fontSize: 12.5, color: 'var(--text-muted)', lineHeight: 1.7, marginBottom: 12 }}>
                Add one line to <strong style={{ color: 'var(--text)' }}>handleModeSelect</strong> in your sidebar to write a <strong style={{ color: 'var(--text)' }}>toolActivity</strong> counter to Firestore. The dashboard reads it automatically.
              </p>
              <pre style={{ background: 'var(--surface-2)', border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)', padding: '12px 14px', fontSize: 11.5, color: 'var(--text)', fontFamily: 'var(--font-mono)', overflowX: 'auto', lineHeight: 1.65, whiteSpace: 'pre-wrap' }}>{
`// In your main app file, add this helper:
import { doc, updateDoc, increment, getFirestore } from 'firebase/firestore';

const trackToolUsage = async (toolId) => {
  const db = getFirestore();
  const uid = auth.currentUser?.uid;
  if (!uid || !toolId) return;
  try {
    await updateDoc(doc(db, 'users', uid), {
      [\`toolActivity.\${toolId}\`]: increment(1),
      lastActiveAt: new Date(),
    });
  } catch (e) { /* non-blocking */ }
};

// Then in your existing handleModeSelect function:
const handleModeSelect = (tool) => {
  setCurrentMode(tool.id);
  setSidebarOpen(false);
  trackToolUsage(tool.id); // <- add this single line
};`
              }</pre>
            </div>
          </>
        )}

        {activeTab === 'logs' && (
          <>
            <p className="cmd-users-meta"><strong>{adminLogs.length}</strong> log {adminLogs.length !== 1 ? 'entries' : 'entry'}</p>
            {adminLogs.length === 0
              ? <div className="cmd-empty" style={{ marginTop: 40 }}><div className="cmd-empty-icon"><IcoSessions size={18} /></div><p>No admin logs yet.</p></div>
              : (
                <div className="cmd-log-list">
                  {adminLogs.map(log => (
                    <div key={log.id} className="cmd-log-row">
                      <div className="cmd-log-top">
                        <div className="cmd-log-action-tag">{(log.action || '').replace(/_/g, ' ')}</div>
                        <div className="cmd-log-ts">{fmtDate(log.timestamp)}</div>
                      </div>
                      <div className="cmd-log-body">
                        <div><strong>Admin:</strong> {log.performedBy}</div>
                        {log.targetUserEmail && <div><strong>User:</strong> {log.targetUserEmail}</div>}
                        {log.deletedData && <div><strong>Deleted:</strong> {log.deletedData.conversations} conversations, {log.deletedData.journals} journals</div>}
                      </div>
                    </div>
                  ))}
                </div>
              )
            }
          </>
        )}

        {activeTab === 'user-detail' && selectedUser && (() => {
          const usage = getUserToolUsage(selectedUser);
          const maxUsage = Math.max(...Object.values(usage), 1);
          const st = activityStatus(selectedUser);
          return (
            <>
              <button className="cmd-btn-back" onClick={() => { setActiveTab('users'); setSelectedUser(null); }}>
                <IcoArrowLeft /> All Users
              </button>
              <div className="cmd-detail-card">
                <div className="cmd-detail-top">
                  <div>
                    <div className="cmd-detail-email">{selectedUser.email}</div>
                    <div className="cmd-detail-uid">{selectedUser.preptuneUserId}</div>
                  </div>
                  <div className={`cmd-status-pill cmd-status--${st.key}`}>{st.label}</div>
                </div>
                <div className="cmd-detail-grid">
                  {[
                    { label: 'Joined',       value: fmtDate(selectedUser.createdAt) },
                    { label: 'Last Active',  value: fmtDate(selectedUser.lastActiveAt) },
                    { label: 'Time Left',    value: fmtTime(selectedUser.callTimer?.remainingTime) },
                    { label: 'Sessions',     value: selectedUser.trialUsage?.sessionsCount || 0 },
                    { label: 'Minutes Used', value: `${(selectedUser.trialUsage?.totalMinutesUsed || 0).toFixed(1)}m` },
                    { label: 'Display Name', value: selectedUser.displayName || '---' },
                    { label: 'Username',     value: selectedUser.settings?.userName || '---' },
                    { label: 'Timezone',     value: selectedUser.timezone || '---' },
                  ].map(({ label, value }) => (
                    <div key={label} className="cmd-detail-cell">
                      <div className="cmd-detail-cell-label">{label}</div>
                      <div className="cmd-detail-cell-value">{String(value)}</div>
                    </div>
                  ))}
                </div>
                <div className="cmd-detail-actions">
                  <button className="cmd-btn-primary" onClick={() => resetTimer(selectedUser.uid, selectedUser.email)}>Reset Timer</button>
                  <button className="cmd-btn-danger-solid" onClick={() => removeUser(selectedUser.uid, selectedUser.email)}>
                    <IcoTrash size={12} /> Delete User
                  </button>
                </div>
              </div>

              <div className="cmd-detail-tools">
                <div className="cmd-detail-tools-title">Tool Usage Breakdown</div>
                <div className="cmd-detail-tool-rows">
                  {TOOLS.map(t => {
                    const val = usage[t.id] || 0;
                    const pct = (val / maxUsage) * 100;
                    return (
                      <div key={t.id} className="cmd-detail-tool-row">
                        <div className="cmd-detail-tool-icon" style={{ background: t.colorBg }}>
                          <ToolIcon id={t.id} size={13} color={t.color} />
                        </div>
                        <div className="cmd-detail-tool-name">{t.label}</div>
                        <div className="cmd-detail-tool-track">
                          <div className="cmd-detail-tool-fill" style={{ width: `${pct}%`, background: t.color }} />
                        </div>
                        <div className="cmd-detail-tool-val">{val}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </>
          );
        })()}

      </main>
    </div>
  );
};

export default AdminDashboard;